<template>
  <Toast />
  <ModalPin
    v-if="modalShowPin"
    @closeModal="closePinModal"
    @submitpin="submitPin"
    :isVoid="cancelIdProduct ? false : true"
  />
  <Dialog
    v-model:visible="showErrorDialog"
    modal
    :closable="true"
    class="w-[90vw] md:w-[50vw] dark:bg-dark-900"
  >
    <template #header>
      <h1 class="text-gray-900 dark:text-gray-200">Terjadi Kesalahan</h1>
    </template>
    <div class="flex items-start space-x-3">
      <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
      <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
    </div>
    <template #footer>
      <Button
        label="Tutup"
        @click="showErrorDialog = false"
        severity="secondary"
      />
    </template>
  </Dialog>
  <Dialog
    v-model:visible="showAlert"
    modal
    :closable="true"
    class="w-[90vw] md:w-[50vw] dark:bg-dark-900"
  >
    <template #header>
      <h1 class="text-gray-900 dark:text-gray-200">{{ headerAlert }}</h1>
    </template>
    <div class="flex items-start space-x-3">
      <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
      <p class="text-gray-700 dark:text-gray-200">{{ alertMessage }}</p>
    </div>
    <template #footer>
      <Button label="Oke" @click="paymentRoute()" severity="success" />
    </template>
  </Dialog>
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded"
      >
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20"
        >
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{
          message.header
        }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button label="Save" @click="acceptCallback" class="w-32"></Button>
          <Button
            label="Cancel"
            outlined
            @click="rejectCallback"
            class="w-32"
          ></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalChooseCustomer
    v-if="modalShowCustomer"
    @closeModal="closeCustomerModal"
    @selectCustomer="selectCustomer"
  />
  <ModalMixItem
    v-if="showModalMix"
    @closeModal="closeModalMix"
    :product="chooseMixItem"
    :allItemCategories="allItemCategories"
    @submitMixItem="submitMixItem"
  />
  <IndexView />
  <div
    id="overlay"
    class="fixed inset-0 bg-black bg-opacity-30 z-30"
    :class="{ hidden: !isBlur }"
  ></div>
  <ViewContainer>
    <div v-if="isLoading" class="p-6 flex justify-center items-center">
      <ProgressSpinner />
    </div>
    <section v-else class="p-6">
      <div
        class="grid grid-cols-1 md:flex md:justify-between md:items-center mb-2"
      >
        <PageTitle
          :title="
            transaction?.code
              ? transaction?.code
                ? 'Order #' + transaction.code
                : ''
              : 'Loading...'
          "
        />
        <div class="flex justify-between flex-wrap items-center gap-2">
          <div
            class="flex items-center gap-2"
            v-if="transaction.status != 'canceled'"
          >
            <button
              @click="showModalPIN"
              class="flex items-center gap-1 px-2 py-1 border border-primary hover:text-white dark:border-light-50 text-primary dark:text-light-50 rounded-lg hover:bg-primary dark:hover:bg-dark-700 dark:hover:text-dark-50 transition-colors text-xs"
            >
              <XMarkIcon class="w-4 h-4" />
              Void
            </button>
            <button
              @click="showModalCustomer"
              class="flex items-center gap-1 px-2 py-1 border border-primary hover:text-white dark:border-light-50 text-primary dark:text-light-50 rounded-lg hover:bg-primary dark:hover:bg-dark-700 dark:hover:text-dark-50 transition-colors text-xs"
            >
              <i class="pi pi-user"></i> Pilih Pelanggan
            </button>
          </div>
          <div
            class="flex items-center gap-2"
            v-if="transaction.status != 'canceled'"
          >
            <button
              id="button-drawer-order"
              @click="toggleDrawer"
              class="flex items-center justify-center p-2 bg-primary text-white rounded-lg hover:bg-primary-600 dark:bg-dark-500 dark:hover:bg-primary-800 transition-colors"
              title="Daftar Order"
            >
              <QueueListIcon class="w-5 h-5" />
            </button>
            <!-- button menu drawer -->
            <div class="block md:hidden">
              <button
                id="button-drawer-menu-items"
                @click="toggleDrawerMenuItems"
                class="flex items-center justify-center p-2 bg-primary text-white rounded-lg hover:bg-primary-600 dark:bg-dark-500 dark:hover:bg-primary-800 transition-colors"
                title="Daftar Menu"
              >
                <BookOpenIcon class="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col lg:grid lg:grid-cols-3 gap-6 h-full overflow-hidden"
      >
        <div
          class="flex-1 lg:col-span-2 bg-white dark:bg-dark-900 rounded-xl px-4 shadow-lg hidden md:block"
        >
          <div class="pt-5">
            <SearchBox
              v-model="searchMenu"
              placeholder="Cari Menu"
              class-add="w-full"
            />
            <FilterLane
              :items="allItemCategories"
              class-add="my-3"
              @setCurrentItem="setCurrentItem"
            />
            <div
              class="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-4 max-h-[calc(100dvh-290px)] overflow-y-auto pb-24"
            >
              <ProductCard
                v-for="item in filteredItems"
                :key="item.id"
                :btnAddItem="'add-item-' + item.id"
                :productName="item.name"
                :productPrice="formatRupiah(item.sale_price)"
                :product="item"
                :image="item.image"
                @add-order="addOrder"
                :isClose="isClose"
              />
            </div>
          </div>
        </div>
        <!-- List Ordered Items -->
        <div
          class="bg-white dark:bg-dark-900 rounded-xl py-4 px-4 shadow-lg lg:col-span-1 flex flex-col h-full"
        >
          <div
            class="flex-1 overflow-y-auto max-h-[calc(100dvh-320px)] md:max-h-[calc(100dvh-290px)] pb-24 relative"
          >
            <ListOrdered
              :order_items="order_items"
              :total="total"
              @add-qty="addQty"
              @add-qty-canceled="addQtyCanceled"
              @reduce-qty="reduceQty"
              @reduce-qty-canceled="reduceQtyCanceled"
              @update-subtotal="updateSubtotalPerItem"
              @update-note="updateNoteOrderedItem"
              @remove-item="removeOrderedItem"
              @edit-note="editNoteOrderedItem"
              @save-note="saveNoteOrderedItem"
              @cancel-order="showModalPIN"
              @print="print"
              @printkitchen="printKitchen"
              @printchecker="printChecker"
              @edit-item-mix="editMixItem"
            />
            <div class="mt-8">
              <DetailComponent :items="viewDetailTotal" />
            </div>
            <div class="mt-8">
              <h3
                class="text-xl font-semibold text-gray-900 dark:text-gray-200 mb-3"
              >
                Detail
              </h3>
              <div class="grid grid-cols-2 gap-3">
                <div
                  class="text-lg font-medium text-gray-500 dark:text-gray-400"
                >
                  Dibuat Oleh
                </div>
                <div class="text-lg text-gray-900 dark:text-gray-100">
                  {{ this.transaction?.cashier || "-" }}
                </div>
              </div>
              <div class="grid grid-cols-2 my-3 gap-3">
                <div
                  class="text-lg font-medium text-gray-500 dark:text-gray-400"
                >
                  Pelanggan
                </div>
                <div class="text-lg text-gray-900 dark:text-gray-100">
                  <span
                    v-if="this.transaction?.customer_name"
                    class="text-gray-500 dark:text-gray-400"
                    >{{ this.transaction?.customer_name }}</span
                  >
                  <span v-else class="text-gray-500 dark:text-gray-400">-</span>
                  <button
                    v-if="this.transaction.customer_name"
                    id="reset-pelanggan"
                    class="text-danger hover:text-hover-danger hover:bg-red-50 dark:hover:bg-red-900/50 rounded-lg transition-colors"
                    @click="resetCustomer"
                  >
                    <TrashIcon class="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Bottom Action Panel -->
      <div
        class="fixed bottom-0 right-0 w-full bg-white dark:bg-dark-900 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 space-y-4 z-30"
      >
        <!-- Primary Actions -->
        <div class="w-full flex justify-center">
          <button
            v-if="allowedSave && order_items.length > 0 && !canClose"
            :id="btnAddItem"
            @click="executeOrder"
            class="w-full max-w-xl text-white py-2 bg-success border-success rounded-xl hover:bg-hover-success hover:text-white font-bold text-lg flex items-center justify-center gap-2 uppercase tracking-wider"
            :disabled="isLoadingComponent"
          >
            {{ isLoadingComponent ? 'Proses Simpan...' : 'Simpan Order' }}
          </button>
          <button
            v-if="order_items.length > 0 && canClose && !isClosing"
            @click="prepareCloseOrder"
            class="w-full max-w-xl text-white py-2 bg-danger border-danger rounded-xl hover:bg-hover-danger hover:text-white font-bold text-lg flex items-center justify-center gap-2 uppercase tracking-wider"
          >
            Close Order
          </button>
        </div>

        <!-- Secondary Actions (when order is closed) -->
        <div v-if="isClose" class="grid grid-cols-2 gap-3">
          <button
            class="flex items-center justify-center gap-2 text-blue-800 py-3 border-2 border-blue-800 rounded-xl hover:bg-blue-800 hover:text-white font-medium text-sm"
          >
            <PrinterIcon class="w-5 h-5" />
            Bill
          </button>
          <a
            href="payment"
            class="flex items-center justify-center gap-2 text-green-800 py-3 border-2 border-green-800 rounded-xl hover:bg-green-800 hover:text-white font-medium text-sm"
          >
            <CreditCardIcon class="w-5 h-5" />
            Pay
          </a>
        </div>

        <!-- Payment Input (when closing) -->
        <div v-if="isClosing" class="space-y-3">
          <InputRupiah
            v-model="payment"
            id="saldo-awal"
            label="Pembayaran"
            input_class="w-full"
          />
          <div class="grid grid-cols-2 gap-3">
            <button
              @click="cancelCloseOrder"
              class="text-gray-800 py-3 border-2 border-gray-300 rounded-xl hover:bg-gray-100 font-medium text-sm flex items-center justify-center gap-2"
            >
              <XCircleIcon class="w-5 h-5" />
              Cancel
            </button>
            <button
              @click="closeOrder"
              class="text-red-800 py-3 border-2 border-red-800 rounded-xl hover:bg-red-800 hover:text-white font-medium text-sm flex items-center justify-center gap-2"
            >
              <CheckCircleIcon class="w-5 h-5" />
              Close
            </button>
          </div>
        </div>
      </div>
      <DrawerPanel
        :isOpen="isDrawerOpen"
        title="Daftar Order"
        @close="toggleDrawer"
      >
        <template #content>
          <div class="p-4">
            <SearchBox
              v-model="searchOrder"
              placeholder="Cari Order"
              class-add="w-full"
            />
            <ListOrder
              :searchOrder="searchOrder"
              :orderType="currentStatusOrder"
            />
          </div>
        </template>
      </DrawerPanel>

      <!-- Drawer for Menu Items -->
      <DrawerPanel
        :isOpen="isDrawerMenuItemsOpen"
        title="Daftar Menu"
        @close="toggleDrawerMenuItems"
        position="right"
      >
        <template #content>
          <div class="p-4">
            <SearchBox
              v-model="searchMenuDrawer"
              placeholder="Cari Menu"
              class-add="w-full"
            />
            <FilterLane
              :items="allItemCategories"
              class-add="my-2 sticky top-0 z-10"
              @setCurrentItem="setCurrentItem"
            />
            <div
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 pb-24 z-0"
            >
              <ProductCard
                v-for="item in filteredItems"
                :key="item.id"
                :btnAddItem="'add-item-' + item.id"
                :productName="item.name"
                :productPrice="formatRupiah(item.sale_price)"
                :product="item"
                :image="item.image"
                @add-order="addOrder"
                :isClose="isClose"
              />
            </div>
          </div>
        </template>
      </DrawerPanel>

      <!-- Drawer for Tables -->
      <DrawerPanel
        :isOpen="isDrawerTablesOpen"
        @close="toggleDrawerTables"
        position="top"
        isfull="true"
      >
        <template #content>
          <NewTransactionCardTable
            :tables="allTables"
            :selectedTableId="selectedTableId"
            title="Daftar Meja"
            caption="Pilih meja yang tersedia"
            @table-selected="handleTableSelected"
          />
          <div class="grid grid-cols-2">
            <Button
              label="Tutup"
              @click="toggleDrawerTables"
              class="w-full mt-4"
              severity="danger"
            />
            <Button label="Pindah" @click="changeTable" class="w-full mt-4" />
          </div>
        </template>
      </DrawerPanel>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import SearchBox from "../SearchBox.vue";
import FilterLane from "./LocalFilterLane.vue";
import ProductCard from "@/views/pages/new-transaction/order/ProductCard.vue";
import ListOrdered from "@/views/pages/new-transaction/order/ListOrdered.vue";
import { formatRupiah } from "@/helpers/formatRupiah";
import DetailComponent from "@/views/pages/new-transaction/DetailComponent.vue";
import {
  CreditCardIcon,
  PrinterIcon,
  QueueListIcon,
  XCircleIcon,
  CheckCircleIcon,
  XMarkIcon,
  BookOpenIcon,
  TrashIcon,
} from "@heroicons/vue/24/solid";
import { mapActions, mapGetters } from "vuex";
import ListOrder from "./ListOrder.vue";
import InputRupiah from "@/components/form/InputRupiah.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import DrawerPanel from "@/components/drawer/DrawerPanel.vue";
import {
  Button,
  ConfirmDialog,
  Dialog,
  ProgressSpinner,
  Toast,
} from "primevue";
import axios from "axios";
import ModalPin from "./ModalPin.vue";
import print from "@/helpers/print";
import ModalChooseCustomer from "@/components/modals/ModalChooseCustomer.vue";
import ModalMixItem from "@/components/modals/ModalMixItem.vue";

export default {
  name: "OrderView",
  components: {
    IndexView,
    PageTitle,
    SearchBox,
    FilterLane,
    ProductCard,
    ListOrdered,
    DetailComponent,
    PrinterIcon,
    CreditCardIcon,
    ListOrder,
    InputRupiah,
    ViewContainer,
    DrawerPanel,
    QueueListIcon,
    XCircleIcon,
    CheckCircleIcon,
    Button,
    Dialog,
    ProgressSpinner,
    ModalPin,
    ConfirmDialog,
    Toast,
    XMarkIcon,
    BookOpenIcon,
    ModalChooseCustomer,
    TrashIcon,
    ModalMixItem,
  },
  computed: {
    ...mapGetters("item_categories", ["allItemCategories"]),
    ...mapGetters("marketings", ["allMarketings"]),
    ...mapGetters("items", ["allItems"]),
    ...mapGetters("tables", ["allTables"]),
    ...mapGetters("settings", ["allSettings"]),
    ...mapGetters("cash_registers", ["allCashRegisters"]),
    ...mapGetters("sales_orders", ["allSalesOrders"]),
    ...mapGetters("users", ["fetchUserById"]),
    ...mapGetters("detail_user", ["detailUser"]),
    taxTotal() {
      const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};
      let result = this.order_items?.reduce(
        (sum, item) =>
          sum +
          (item.tax_applied
            ? (item.status == "canceled" ? -1 : 1) *
              parseInt(
                (settings.tax / 100) *
                  (item.price - item.discount_price) *
                  item.quantity
              )
            : 0),
        0
      );
      return result;
    },
    relevantCashRegister() {
      return this.allCashRegisters?.find((cr) => !cr.time_end);
    },
    currentTable() {
      console.log(
        "halo",
        this.transaction.table_id,
        this.allTables,
        this.allTables?.find((table) => table.id === this.transaction.table_id)
      );
      console.log(this.transaction);
      if (!this.transaction?.table_id) return null;
      return this.allTables?.find(
        (table) => table.id === this.transaction.table_id
      );
    },
    currentMarketing() {
      const id = this.transaction?.marketing_id;
      console.log(id);
      return this.allMarketings?.find((marketing) => marketing.id == id);
    },
    order_id() {
      return this.$route.query.orderId;
    },
    filteredItems() {
      // Filter item berdasarkan kategori yang dipilih
      let result = this.allItems;
      result = result.map((item) => {
        item.itemCategory = this.allItemCategories.find(
          (ic) => ic.id == item.item_category_id
        );
        item.image = item.image_url ? `${process.env.VUE_APP_WEBSOCKET_URL}/file/${item.image_url}` : null;
        return item;
      });

      result = result.filter((item) => item.itemCategory !== undefined);
      if (this.searchMenuDrawer)
        result = result.filter(
          (item) =>
            item?.name
              .toUpperCase()
              .indexOf(this.searchMenuDrawer.toUpperCase()) > -1
        );
      if (this.searchMenu)
        result = result.filter(
          (item) =>
            item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
        );
      if (this.selectedCategory) {
        result = result.filter(
          (item) => item.item_category_id === this.selectedCategory
        );
      }
      return result;
    },
    ordered_items_print(id_categories) {
      let result = this.order_items.map((item) => {
        // First get the item details
        item.item_detail = this.allItems.find((i) => i.id === item.item_id);
        // Then get the category with printer list
        item.item_categories = this.allItemCategories.find(
          (ic) => ic.id === item.item_detail?.item_category_id
        );
        return item;
      });

      if (!id_categories) return result;
      return result.filter((item) =>
        item?.item_categories?.printer_list.some(
          (printer) =>
            console.log(this.division_print) ||
            printer.id == this.division_print
        )
      );
    },
    division_print() {
      return this.division;
    },
    viewDetailTransaksi() {
      return [
        { field: "No. Invoice", value: this.transaction.code, type: "text" },
        { field: "Meja", value: this.currentTable?.name, type: "text" },
        { field: "Tanggal", value: new Date(), type: "date" },
        {
          field: "Nama Tamu",
          value: this.transaction.customer_name,
          type: "text",
        },
        { field: "Kasir", value: this.transaction?.cashier, type: "text" },
        {
          field: "Marketing",
          value: this.currentMarketing?.name || "-",
          type: "text",
        },
      ];
    },
    viewDetailTotal() {
      console.log("order_items: ", this.order_items);

      const subtotal = this.order_items.reduce(
        (sum, item) =>
          sum + item.subtotal * (item.status == "canceled" ? -1 : 1),
        0
      );
      let discount = 0;
      discount = this.order_items.reduce(
        (sum, item) =>
          sum +
          item.discount_price *
            item.quantity *
            (item.status == "canceled" ? -1 : 1),
        0
      );
      let total = subtotal - discount + this.taxTotal;
      console.log("total: ", total);
      total = Math.ceil(total);

      return [
        { field: "Sub Total", value: subtotal, type: "rupiah" },
        { field: "Diskon", value: discount, type: "rupiah" },
        { field: "Tax", value: this.taxTotal, type: "rupiah" },
        { field: "Total", value: total, type: "rupiah" },
      ];
    },
    viewDetailRingkasan() {
      return [
        // { field: "Marketing", value: "Erista Dwatiga", type: "text" },
        {
          field: "Pelanggan",
          value:
            this.transaction?.order_type == "staff"
              ? "staff"
              : this.transaction?.customer_name,
          type: "text",
        },
      ];
    },
    canClose() {
      let response = true;
      const orderItems = this.order_items;
      for (let index = 0; index < orderItems.length; index++) {
        const orderItem = orderItems[index];
        if (orderItem.isEdit) {
          response = false;
        }
      }
      const subtotal = this.viewDetailTotal.find(
        (v) => v.field == "Sub Total"
      )?.value;
      if (subtotal <= 0) {
        response = subtotal;
      }
      response =
        !["paid", "canceled"].includes(this.transaction?.status) &&
        !this.allowedSave;
      return response;
    },
  },
  watch: {
    "$route.query.orderId": {
      immediate: true,
      handler(newId) {
        if (newId && this.allSalesOrders) {
          const order = this.allSalesOrders.find(
            (o) => o.id === parseInt(newId)
          );
          if (order) {
            this.transaction = { ...order };
          }
          this.checkAndRefreshOrder();
        }
      },
    },
    allSalesOrders: {
      immediate: true,
      handler(orders) {
        if (orders && this.$route.query.orderId) {
          const order = orders.find(
            (o) => o.id === parseInt(this.$route.query.orderId)
          );
          if (order) {
            this.transaction = { ...order };
          }
          this.checkAndRefreshOrder();
        }
      },
    },
  },
  data() {
    return {
      payment: 0,
      isClosing: false,
      showErrorDialog: false,
      errorMessage: "",
      isLoading: true,
      isLoadingComponent: false,
      isBlur: false,
      itemCategory: ["Makanan", "Minuman"],
      items: [],
      allowedSave: false,
      isClose: false,
      order_items: [],
      selectedProduct: null,
      selectedCategory: null,
      modalShowNote: false,
      btnAddItem: "add-item",
      viewtotalreceipt: [],
      viewpaymentreceipt: [],
      division: 2,
      transaction: {
        id: 1,
        code: "MK01",
        table: "Meja 1",
        cashier: "Kasir 1",
        total: "20000",
        discount: "0",
        service_charge: "0",
        service_tax: "0",
        grand_total: "20000",
      },
      statusEksekusi: [
        { name: "Belum Eksekusi" },
        { name: "Proses Eksekusi" },
        { name: "Sudah Eksekusi" },
      ],
      statusTable: [
        "available",
        "ready",
        "reserved",
        "not_ordered",
        "maintenance",
      ],
      currentStatusOrder: null,
      spanStatus: {
        available: "bg-yellow-100 text-yellow-800",
        ready: "bg-green-100 text-green-800",
        reserved: "bg-blue-100 text-blue-800",
        not_ordered: "bg-gray-100 text-gray-800",
        maintenance: "bg-red-100 text-red-800",
      },
      buttonClassStatus: {
        available: "bg-green-500 hover:bg-green-600",
        ready: "bg-yellow-500 hover:bg-yellow-600",
        reserved: "bg-blue-500 hover:bg-blue-600",
        not_ordered: "bg-blue-500 hover:bg-blue-600",
        maintenance: "bg-gray-500 cursor-not-allowed",
      },
      allowedOrder: ["available", "ready", "not_ordered", "reserved"],
      tables: [],
      listTransaksi: [
        {
          id: 1,
          name: "Erista",
          table: "Meja 1",
          status: "Active",
          type: "Dine In",
        },
      ],
      orderType: [
        {
          id: "dine_in",
          name: "Dine In",
        },
        {
          id: "take_away",
          name: "Take Away",
        },
        {
          id: "staff",
          name: "Staff",
        },
      ],
      isDrawerOpen: false,
      isDrawerMenuItemsOpen: false,
      isDrawerTablesOpen: false,
      cancelIdProduct: null,
      selectedTableId: null,
      canReserve: ["available", "ready"],
      validation_transaction: {
        marketing_id: {
          valid: true,
          message: "",
        },
      },
      field_transaction: ["marketing_id"],
      items_print: [],
      searchOrder: "",
      searchMenuDrawer: "",
      searchMenu: "",
      showAlert: false,
      alertMessage: "",
      headerAlert: "",
      modalShowCustomer: false,
      showModalMix: false,
      chooseMixItem: null,
    };
  },
  async created() {
    try {
      // Load all required data
      const requiredData = {
        itemCategories: await this.$store.dispatch(
          "item_categories/fetchItemCategories",
          {
            limit: 1000,
            status: "active",
          }
        ),
        items: await this.$store.dispatch("items/fetchItems", {
          limit: 1000,
          is_active: true,
        }),
        settings: await this.$store.dispatch("settings/fetchSettings"),
        cash_registers: await this.$store.dispatch(
          "cash_registers/fetchCashRegisters"
        ),
        staffs: await this.$store.dispatch("marketings/fetchMarketings"),
      };

      await this.$store.dispatch("detail_user/fetchUser");

      for (var i in requiredData) {
        if (requiredData[i] == undefined) {
          this.$toast.add({
            severity: "error",
            summary: "Gagal",
            detail: "Gagal mengambil data " + i,
            life: 3000,
          });
        }
      }

      // Initialize empty order items
      this.order_items = [];

      // Get current cash register and load orders
      const cashRegister = this.allCashRegisters?.find((cr) => !cr.time_end);
      if (cashRegister) {
        // Load sales orders and wait for them to be available
        let cashRegisterResponse = await this.$store.dispatch(
          "sales_orders/fetchSalesOrders",
          {
            cash_register_id: cashRegister.id,
          },
          { limit: 1000 }
        );

        if (cashRegisterResponse == undefined) {
          this.$toast.add({
            severity: "error",
            summary: "Gagal",
            detail: "Gagal mengambil data cash register",
            life: 3000,
          });
        }

        // Wait a bit for the store to update
        await new Promise((resolve) => setTimeout(resolve, 100));

        // Load specific order if we have an ID
        const orderId = parseInt(this.$route.query.orderId);
        if (orderId) {
          await this.checkAndRefreshOrder();
        }
      }

      this.isLoading = false;
    } catch (error) {
      this.errorMessage =
        error.message ||
        "Terjadi kesalahan saat memuat data. Silakan coba lagi.";
      this.showErrorDialog = true;
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions("sales_orders", [
      "createSalesOrder",
      "updateSalesOrder",
      "closeSalesOrder",
    ]),
    ...mapActions("sales_order_menus", ["createSalesOrderMenu"]),
    ...mapActions("tables", ["updateTable"]),
    formatRupiah,
    paymentRoute() {
      const orderId = this.transaction.id;
      if (orderId) {
        this.$router.push({ name: "payment", query: { orderId } });
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    },
    formatDate(date) {
      console.log(date);
      if (!date) return "-";
      const d = new Date(date);
      const pad = (num) => num.toString().padStart(2, "0");

      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = d.getFullYear().toString().slice(-2);
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    },
    async fetchUsers(userId) {
      const responseUser = await this.$store.dispatch(
        "users/fetchUserById",
        userId
      );
      return responseUser?.data;
    },
    async loadData() {
      // Load all required data
      await Promise.all([
        this.$store.dispatch("tables/fetchTables"),
        this.$store.dispatch("products/fetchProducts"),
        this.$store.dispatch("cash_registers/fetchCashRegisters"),
        this.$store.dispatch("settings/fetchSettings"),
      ]);

      // Get the current cash register
      const cashRegister = this.allCashRegisters?.find((cr) => !cr.time_end);
      if (cashRegister) {
        // Load sales orders for this cash register
        await this.$store.dispatch(
          "sales_orders/fetchSalesOrders",
          {
            cash_register_id: cashRegister.id,
          },
          { limit: 1000 }
        );

        // Get the order ID from query params
        const orderId = parseInt(this.$route.query.orderId);
        if (orderId && this.allSalesOrders) {
          const order = this.allSalesOrders.find((o) => o.id === orderId);
          if (order) {
            this.transaction = { ...order };
            this.order_items = [...(order.order_items || [])];
          }
        }
      }

      this.checkAndRefreshOrder();
    },
    setCurrentItem(item) {
      this.selectedCategory = item;
    },
    setCurrentStatusOrder(order) {
      this.currentStatusOrder = order;
    },
    showModal() {
      this.modalShowNote = true;
      this.isBlur = true;
      this.selectedProduct = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowNote = false;
        this.isBlur = false;
      }, 200);
    },
    closePinModal() {
      setTimeout(() => {
        this.modalShowPin = false;
        this.isBlur = false;
      }, 200);
    },
    editNoteOrderedItem(item) {
      this.selectedProduct = item;
      this.modalShowNote = true;
      this.allowedSave = true;
    },
    saveNoteOrderedItem(note) {
      this.selectedProduct.note = note;
      this.closeModal();
      this.allowedSave = true;
    },
    showSelectedProduct(product) {
      this.selectedProduct = product;
      this.showModal();
    },
    addOrder(product) {
      console.log("product add order", product);
      let lastId = this.order_items.reduce(
        (max, item) => (item.id > max ? item.id : max),
        0
      );
      if (!["paid", "canceled"].includes(this.transaction?.status)) {
        if (product.has_product_mix) {

          this.showModalMixItem(product);
          this.allowedSave = true;
        } else {
          this.order_items.push({
            id: lastId + 1,
            item_id: product.id,
            name: product.name,
            quantity: 1,
            price: product.sale_price,
            subtotal: parseFloat(product.sale_price) * 1,
            payment_status: 1,
            note: null,
            isEdit: true,
            isPrint: true,
            status: "unsaved",
            discount_price: product.discount_price,
            total: parseFloat(product.sale_price - product.discount_price) * 1,
            created_at: new Date(),
            is_print_checker: false,
            is_print_kitchen: false,
            order_type: this.transaction.order_type,
            service_charge_applied: product.service_charge_applied,
            tax_applied: product.tax_applied,
            discount_applied: product.discount_applied,
            createdAt: new Date(),
            create_by: this.detailUser.id,
            has_product_mix: product.has_product_mix,
            product_mix: product.product_mix,
            selected_product_mix: [],
            totalBeforeDiscount: parseFloat(product.sale_price) * 1,
            totalAfterDiscount: parseFloat(product.sale_price - product.discount_price) * 1,
          });
          this.allowedSave = true;
        }
      } else {
        this.errorMessage =
          "Anda tidak bisa menambahkan order baru. Karena order ini diselesaikan.";
        this.showErrorDialog = true;
      }
    },
    showModalPIN(product = null) {
      if (["paid", "canceled"].includes(this.transaction?.status)) {
        this.errorMessage =
          "Anda tidak bisa melakukan aksi ini. Karena order ini sudah diselesaikan.";
        this.showErrorDialog = true;
      } else {
        this.modalShowPin = true;
        this.cancelIdProduct = product ? product.item_id : null;
        this.isBlur = true;
      }
    },
    submitPin(data) {
      const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};
      if (data.pin && data.pin == settings.pin_code) {
        if (this.cancelIdProduct) {
          this.cancelOrder(this.cancelIdProduct);
        } else {
          this.confirmVoidTransaction(data.note);
        }
      } else {
        this.errorMessage = "PIN yang Anda masukkan salah. Silakan coba lagi.";
        this.showErrorDialog = true;
      }
    },
    cancelOrder(product) {
      product = { ...this.allItems.find((p) => p.id == product) };
      console.log("product", product);
      let lastId = this.order_items.reduce(
        (max, item) => (item.id > max ? item.id : max),
        0
      );
      let allowedCancel = this.order_items.reduce((sum, menu) => {
        return (
          sum +
          (menu.item_id == product.id
            ? menu.quantity * (menu.status == "canceled" ? -1 : 1)
            : 0)
        );
      }, 0);
      console.log("allowedCancel", allowedCancel);
      if (!allowedCancel) {
        this.errorMessage =
          "Anda tidak bisa membatalkan order ini. Karena order ini sudah dibatalkan sebelumnya.";
        this.showErrorDialog = true;
        return;
      }
      this.order_items.push({
        id: lastId + 1,
        item_id: product.id,
        name: product.name,
        quantity: 1,
        price: parseFloat(product.sale_price),
        subtotal: parseFloat(product.sale_price) * 1,
        payment_status: 1,
        note: null,
        isEdit: true,
        isPrint: true,
        status: "canceled",
        discount_price: product.discount_price,
        total: parseFloat(product.sale_price) * 1,
        created_at: new Date(),
        is_print_checker: false,
        is_print_kitchen: false,
        order_type: product.order_type,
        create_by: this.detailUser.id,
        totalBeforeDiscount: parseFloat(product.sale_price) * 1,
        totalAfterDiscount: parseFloat(product.sale_price - product.discount_price) * 1,
      });
      this.allowedSave = true;
    },
    addQty(item) {
      item.quantity++;
      item.subtotal = parseFloat(item.price - item.discount_price) * 1 * item.quantity;
      item.totalBeforeDiscount = parseFloat(item.price) * 1 * item.quantity;
      item.totalAfterDiscount = parseFloat(item.price - item.discount_price) * 1 * item.quantity;
      this.allowedSave = true;
    },
    addQtyCanceled(item) {
      let totalQty = 0;
      this.order_items.forEach((orderItem) => {
        if (
          orderItem.status != "canceled" &&
          orderItem.item_id == item.item_id
        ) {
          totalQty += orderItem.quantity;
        }
      });

      if (item.quantity < totalQty) {
        item.quantity++;
        item.subtotal = parseFloat(item.price) * 1 * item.quantity;
        item.totalBeforeDiscount = parseFloat(item.price) * 1 * item.quantity;
        item.totalAfterDiscount = parseFloat(item.price - item.discount_price) * 1 * item.quantity;
        this.allowedSave = true;
      } else {
        this.errorMessage = `Qty cancel maksimal: ${totalQty}.`;
        this.showErrorDialog = true;
      }
    },
    reduceQty(item) {
      if (item.quantity > 1) {
        item.quantity--;
        item.subtotal = parseFloat(item.price - item.discount_price) * 1 * item.quantity;
        item.totalBeforeDiscount = parseFloat(item.price) * 1 * item.quantity;
      item.totalAfterDiscount = parseFloat(item.price - item.discount_price) * 1 * item.quantity;
        this.allowedSave = true;
      }
    },
    reduceQtyCanceled(item) {
      if (item.quantity > 1) {
        item.quantity--;
        item.subtotal = parseFloat(item.price) * 1 * item.quantity;
        item.totalBeforeDiscount = parseFloat(item.price) * 1 * item.quantity;
        item.totalAfterDiscount = parseFloat(item.price - item.discount_price) * 1 * item.quantity;
        this.allowedSave = true;
      }
    },
    removeOrderedItem(item) {
      this.order_items = this.order_items.filter(
        (orderItem) => orderItem.id !== item.id
      );
      this.allowedSave = true;
    },
    async executeOrder() {
      console.log("execute", this.order_items);
      this.isLoadingComponent = true;
      this.$confirm.require({
        group: "headless",
        header: "Apakah anda yakin ingin menyimpan order ini?",
        message: "Silahkan konfirmasi sebelum diproses.",
        accept: async () => {
          this.allowedSave = false;
          const orderId = await this.saveOrder();
          this.$toast.add({
            severity: "success",
            summary: "Sukses",
            detail: "Kamu telah menyimpan order.",
            life: 3000,
          });
          this.$router.push({
            name: "order",
            query: { ...this.$route.query, orderId, new: false },
          });

          this.checkAndRefreshOrder();
          this.isLoadingComponent = false;
        },
        reject: () => {
          this.$toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "Kamu telah membatalkan penyimpanan order",
            life: 3000,
          });
          this.isLoadingComponent = false;
        },
      });
    },
    async saveOrder() {
      const routeQuery = this.$route.query;

      let orderId = routeQuery.orderId;
      try {
        if (orderId == null || orderId == undefined) {
          console.log("create");
          const response = await this.createSalesOrder({
            table_id: routeQuery.tableId,
            marketing_id: routeQuery.marketingId,
            //   payment_method_id: null,
            cash_register_id: routeQuery.cashRegisterId,
            transaction_type_id: routeQuery.transactionTypeId,
            customer_name: routeQuery.customerName,
            customer_phone: "",
            sub_total: this.viewDetailTotal.find((d) => d.field == "Sub Total")
              .value,
            grand_total: this.viewDetailTotal.find((d) => d.field == "Total")
              .value,
            status: "pending", // DataTypes.ENUM("pending", "paid", "canceled")
            order_type: routeQuery.orderType, // DataTypes.ENUM("dine_in", "take_away", "delivery")
            payment_amount: 0,
            payment_change: 0,
            tax: this.taxTotal,
            service_charge: 0,
            discount: this.viewDetailTotal.find((d) => d.field == "Diskon")
              .value,
            note: "",
          });
          orderId = response.data.id;
        } else {
          let update = {
            id: orderId,
            table_id: this.transaction.table_id, // Fix: Use table_id instead of table
            marketing_id: this.transaction.marketing_id,
            //   payment_method_id: null,
            cash_register_id:
              this.transaction.cash_register_id == null
                ? this.relevantCashRegister?.id
                : this.transaction.cash_register_id,
            transaction_type_id: this.transaction.transaction_type_id,
            customer_name: this.transaction.customer_name,
            customer_phone: "",
            sub_total: this.viewDetailTotal.find((d) => d.field == "Sub Total")
              .value,
            grand_total: this.viewDetailTotal.find((d) => d.field == "Total")
              .value,
            status: "pending", // DataTypes.ENUM("pending", "paid", "canceled")
            order_type: this.transaction.order_type, // DataTypes.ENUM("dine_in", "take_away", "delivery")
            payment_amount: 0,
            payment_change: 0,
            tax: this.taxTotal,
            service_charge: 0,
            discount: this.viewDetailTotal.find((d) => d.field == "Diskon")
              .value,
            note: "",
          };
          await this.updateSalesOrder(update);
        }

        const orderItems = this.order_items;
        for (let key = 0; key < orderItems.length; key++) {
          const orderItem = orderItems[key];

          if (orderItem.isEdit) {
            const response = await this.createSalesOrderMenu({
              sales_order_id: orderId,
              item_id: orderItem.item_id,
              qty: orderItem.quantity,
              price: orderItem.price,
              discount_price: orderItem.discount_price,
              note: orderItem.note,
              order_type:
                orderItem.status == "canceled"
                  ? this.transaction.order_type
                  : orderItem.order_type,
              status:
                orderItem.status == "unsaved" ? "pending" : orderItem.status,
              is_print_checker: true,
              service_charge_applied: orderItem.service_charge_applied,
              tax_applied: orderItem.tax_applied,
              discount_applied: orderItem.discount_applied,
              has_product_mix: orderItem.has_product_mix,
              product_mix: orderItem.selected_product_mix,
              outlet_id: orderItem.outlet_id,
              mix_qty_per_unit: orderItem.mix_qty_per_unit,
            });
            console.log("save order", response.data);
          }
        }
      } catch (error) {
        // Handle error message
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error.response.data.message,
          life: 3000,
        });
        this.checkAndRefreshOrder();
      }

      return orderId;
    },
    async changeTable() {
      this.$confirm.require({
        group: "headless",
        header: "Apakah anda yakin ingin pindah meja?",
        message: "Silahkan konfirmasi sebelum diproses.",
        accept: async () => {
          const routeQuery = this.$route.query;
          const previousTable = this.currentTable.id;
          console.log("previousTable", previousTable);

          let orderId = routeQuery.orderId;
          try {
            await this.updateSalesOrder({
              id: orderId,
              table_id: this.selectedTableId, // Fix: Use table_id instead of table
              marketing_id: this.transaction.marketing_id,
              //   payment_method_id: null,
              cash_register_id:
                this.transaction.cash_register_id == null
                  ? this.relevantCashRegister?.id
                  : this.transaction.cash_register_id,
              transaction_type_id: this.transaction.transaction_type_id,
              customer_name: this.transaction.customer_name,
              customer_phone: "",
              sub_total: this.viewDetailTotal.find(
                (d) => d.field == "Sub Total"
              ).value,
              grand_total: this.viewDetailTotal.find((d) => d.field == "Total")
                .value,
              status: "pending", // DataTypes.ENUM("pending", "paid", "canceled")
              order_type: this.transaction.order_type, // DataTypes.ENUM("dine_in", "take_away", "delivery")
              payment_amount: 0,
              payment_change: 0,
              tax: this.taxTotal,
              service_charge: 0,
              discount: this.viewDetailTotal.find((d) => d.field == "Diskon")
                .value,
              note: "",
            });

            await this.updateTable({
              id: previousTable,
              status: "available",
            });
            await this.updateTable({
              id: this.selectedTableId,
              status: "unavailable",
            });
            this.checkAndRefreshOrder();
          } catch (error) {
            // Handle error message
            this.errorMessage = "Pindah table gagal. Silakan coba lagi.";
            this.showErrorDialog = true;
            this.checkAndRefreshOrder();
          }
          this.toggleDrawerTables();
          this.$toast.add({
            severity: "success",
            summary: "Sukses",
            detail: "Pindah meja sukses.",
            life: 3000,
          });
          return orderId;
        },
        reject: () => {
          this.$toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "Kamu telah membatalkan perpindahan meja",
            life: 3000,
          });
        },
      });
    },
    async closeOrder() {
      // this.allowedSave = false;
      // this.isClose = true;
      // this.order_items.forEach(function (order_items) {
      //     order_items.isEdit = false;
      // });

      const routeQuery = this.$route.query;

      let orderId = routeQuery.orderId;
      const response = await this.closeSalesOrder({
        id: orderId,
        transaction_id: orderId,
        table_id: this.transaction.table_id, // Fix: Use table_id instead of table
        marketing_id: this.transaction.marketing_id,
        payment_method_id: null,
        cash_register_id: this.transaction.cash_register_id,
        transaction_type_id: this.transaction.transaction_type_id,
        customer_name: this.transaction.customer_name,
        customer_phone: "",
        sub_total: this.viewDetailTotal.find((d) => d.field == "Sub Total")
          .value,
        grand_total: this.viewDetailTotal.find((d) => d.field == "Total").value,
        status: "close", // DataTypes.ENUM("pending", "paid", "canceled")
        order_type: this.transaction.order_type,
        payment_amount: this.payment,
        payment_change: 0,
        tax: this.viewDetailTotal.find((d) => d.field == "Service Tax").value,
        service_charge: this.viewDetailTotal.find(
          (d) => d.field == "Service Charge"
        ).value,
        discount: this.viewDetailTotal.find((d) => d.field == "Diskon").value,
        note: "",
      });

      console.log(response);

      await this.updateTable({
        id: routeQuery.tableId,
        status: "available",
      });

      this.$router.push({ name: "Dashboard" });
    },
    async checkAndRefreshOrder() {
      this.order_id = this.$route.query.orderId;
      if (this.order_id != null) {
        const response = await this.$store.dispatch(
          "sales_orders/fetchSalesOrderById",
          this.order_id
        );

        // Wait a bit for the store to update
        await new Promise((resolve) => setTimeout(resolve, 100));

        if (response.status != "success") {
          this.$toast.add({
            severity: "error",
            summary: "Gagal",
            detail: "Gagal mengambil data sales order",
            life: 3000,
          });
          return;
        }

        const salesOrder = response.data;
        let responseUser = null;
        if (salesOrder.create_by) {
          responseUser = await this.$store.dispatch(
            "users/fetchUserById",
            salesOrder.create_by
          );
        }
        this.transaction = {
          id: salesOrder.id,
          code: salesOrder.code,
          table_id: salesOrder.table_id, // Fix: Use table_id instead of table
          marketing_id: salesOrder.marketing_id,
          cash_register_id:
            salesOrder.cash_register_id == null
              ? this.relevantCashRegister?.id
              : salesOrder.cash_register_id,
          transaction_type_id: salesOrder.transaction_type_id,
          customer_name: salesOrder.customer_name,
          order_type: salesOrder.order_type,
          cashier: responseUser?.data ? responseUser.data.name : "Unknown",
          total: salesOrder.sub_total,
          discount: salesOrder.discount,
          service_charge: salesOrder.service_charge,
          service_tax: salesOrder.tax,
          grand_total: salesOrder.grand_total,
          createdAt: salesOrder.createdAt,
          status: salesOrder.status,
        };
        this.order_items = salesOrder.menus.map((menu) => {
          let valid = false;
          try {
            JSON.parse(menu.product_mix);
            valid = true;
          } catch {
            valid = false;
          }
          
          return {
            id: menu.id,
            item_id: menu.item_id,
            name: menu?.items?.name,
            quantity: menu.qty,
            price: menu.price,
            subtotal: menu.qty * menu.price,
            is_print_kitchen: menu.is_print_kitchen,
            is_print_checker: menu.is_print_checker,
            payment_status: 1,
            note: menu.note,
            isEdit: false,
            isPrint: true,
            status: menu.status,
            discount_price: menu.discount_price || 0,
            total: menu.qty * (menu.price - menu.discount_price),
            createdAt: menu.createdAt,
            order_type: menu.order_type,
            service_charge_applied: menu.service_charge_applied,
            tax_applied: menu.tax_applied,
            discount_applied: menu.discount_applied,
            create_by: menu.create_by,
            has_product_mix: menu.has_product_mix,
            image: menu.image_url ? `${process.env.VUE_APP_WEBSOCKET_URL}/file/${menu.image_url}` : null,
            product_mix: menu.has_product_mix
              ? valid
                ? JSON.parse(menu.product_mix)
                : menu.product_mix
              : [],
            mix_qty_per_unit: menu.mix_qty_per_unit,
            totalBeforeDiscount: menu.qty * menu.price,
            totalAfterDiscount: menu.qty * (menu.price - menu.discount_price),
          };
        });
        console.log("see:", this.order_items);

        console.log("see:", salesOrder);
      }

      return true;
    },
    prepareCloseOrder() {
      const orderId = this.transaction.id;
      if (orderId) {
        this.$router.push({ name: "payment", query: { orderId } });
      }
      // this.isClosing = true;
    },
    cancelCloseOrder() {
      this.isClosing = false;
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    toggleDrawerMenuItems() {
      if (!["paid", "canceled"].includes(this.transaction?.status)) {
        this.isDrawerMenuItemsOpen = !this.isDrawerMenuItemsOpen;
        this.searchMenuDrawer = "";
        this.searchMenu = "";
        this.selectedCategory = null;
      } else {
        this.errorMessage = "Transaksi sudah selesai. Tidak dapat menambahkan menu.";
        this.showErrorDialog = true;
      }
    },
    toggleDrawerTables() {
      if (!["paid", "canceled"].includes(this.transaction?.status)) {
        this.isDrawerTablesOpen = !this.isDrawerTablesOpen;
      } else {
        this.errorMessage = "Transaksi sudah selesai. Tidak dapat pindah meja.";
        this.showErrorDialog = true;
      }
    },
    async formatElementForPrinting() {
      let printText = "";
      let totalDiscount = 0;
      let totalPrice = 0;
      // Get all text content from the element
      const rows = [];

      // Add company header with center alignment
      rows.push("\x1b\x61\x01"); // Center alignment
      rows.push(process.env.VUE_APP_STORE_NAME);
      rows.push(process.env.VUE_APP_STORE_ADDRESS);
      rows.push(process.env.VUE_APP_STORE_PHONE);
      rows.push(print.breakLine(40, "="));

      // Add transaction details
      rows.push(print.breakLine(40, "="));

      this.viewDetailTransaksi.forEach((detail) => {
        let value =
          detail.field == "Tanggal"
            ? this.formatDate(detail.value)
            : detail.value;
        if (["No. Invoice"].includes(detail.field)) {
          rows.push(
            print.twoColumn(`${detail.field}`, `: ${value}`, 12, 0, 28)
          );
        }
      });
      // rows.push(`Order ID:${item.id}`);
      rows.push(print.breakLine(40, "="));

      // Add order items
      this.order_items.forEach((item) => {
        rows.push(print.twoColumn(`${item.name}`, "", 17, 6, 17));
        rows.push(
          print.twoColumn(
            `  ${item.quantity} x ${
              item.status == "canceled" ? "-" : ""
            }Rp ${Number(item.price).toLocaleString()}`,
            `Rp${Number(item.price).toLocaleString()}`,
            17,
            6,
            17
          )
        );
        let subTotal = Number(item.price) * Number(item.quantity);
        totalPrice += (item.status == "canceled" ? -1 : 1) * subTotal;
        if (item.discount_price > 0) {
          rows.push(
            print.twoColumn(
              `  Discount:`,
              `-Rp${Number(item.discount_price).toLocaleString()}`,
              17,
              6,
              17
            )
          );
          totalDiscount +=
            (item.status == "canceled" ? -1 : 1) *
            (item.discount_price * item.quantity);
        }
      });

      rows.push(print.breakLine(40, "-"));

      // Add payment details with proper spacing
      rows.push(
        print.twoColumn(
          `Sub Total:`,
          `Rp${Number(totalPrice).toLocaleString()}`,
          17,
          6,
          17
        )
      );
      rows.push(
        print.twoColumn(
          `Diskon:`,
          `-Rp${Number(totalDiscount).toLocaleString()}`,
          17,
          6,
          17
        )
      );
      rows.push(
        print.twoColumn(
          `Service Charge:`,
          `Rp${Number(this.transaction?.service_charge).toLocaleString()}`,
          17,
          6,
          17
        )
      );
      rows.push(
        print.twoColumn(
          `Service Tax:`,
          `Rp${Number(this.transaction?.service_tax).toLocaleString()}`,
          17,
          6,
          17
        )
      );
      rows.push(
        print.twoColumn(
          `Total:`,
          `Rp${Number(this.transaction?.grand_total).toLocaleString()}`,
          17,
          6,
          17
        )
      );

      // Add footer with center alignment
      rows.push("\x1b\x61\x01"); // Center alignment
      rows.push(print.breakLine(40, "="));

      rows.push("Terima Kasih Atas Pembelian Anda!");

      rows.push(print.breakLine(40, "="));
      rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
      rows.push("\n\n\n"); // Extra lines for paper cut

      // Join all rows with newlines and add some spacing
      printText = rows.join("\n");

      console.log(printText);

      return printText;
    },
    async formatKitchen(item, printer) {
      // Get all text content from the element
      let printText = "";
      const rows = [];

      // Add order items
      rows.push(print.breakLine(40, "="));

      if (item.status == "canceled") {
        rows.push(`\x1b\x61\x01 \x1b\x21\x10CANCEL`);
      }
      rows.push(`\x1b\x61\x01 \x1b\x21\x01Table: ${this.currentTable.name}`);
      rows.push(print.breakLine(40, "="));

      this.viewDetailTransaksi.forEach((detail) => {
        let value =
          detail.field == "Tanggal"
            ? this.formatDate(detail.value)
            : detail.value;
        if (["No. Invoice"].includes(detail.field)) {
          rows.push(
            print.twoColumnLeftAlign(`${detail.field}`, `: ${value}`, 12, 0, 28)
          );
        }
      });
      // rows.push(`Order ID:${item.id}`);
      rows.push(
        print.twoColumnLeftAlign(
          `Item`,
          `: ${item.name} ${item.status == "canceled" ? "(canceled)" : ""}`,
          12,
          0,
          28
        )
      );
      rows.push(
        print.twoColumnLeftAlign(`Kategori`, `: ${item.order_type}`, 12, 0, 28)
      );
      rows.push(
        print.twoColumnLeftAlign(`Jumlah`, `: ${item.quantity}`, 12, 0, 28)
      );
      rows.push(
        print.twoColumnLeftAlign(`Catatan`, `: ${item.note || "-"}`, 12, 0, 28)
      );
      rows.push(print.breakLine(40, "="));
      rows.push(`\x1b\x61\x01Waktu: ${this.formatDate(item.createdAt)}`);
      rows.push(`${printer}`);
      rows.push(print.breakLine(40, "="));

      printText = rows.join("\n");

      return printText;
    },
    async formatChecker(items, time) {
      // Get all text content from the element
      let printText = "";
      const distinctValues = [...new Set(items?.map((item) => item.create_by))];
      const rows = [];

      // Add transaction details
      rows.push(
        print.twoColumnLeftAlign(
          `No. Invoice`,
          `: ${this.transaction?.code || "-"}`,
          12,
          0,
          28
        )
      );
      rows.push(
        print.twoColumnLeftAlign(
          `Meja`,
          `: ${this.currentTable?.name || "-"}`,
          12,
          0,
          28
        )
      );
      rows.push(
        print.twoColumnLeftAlign(
          `Tanggal`,
          `: ${this.formatDate(time)}`,
          12,
          0,
          28
        )
      );
      const waiter = await this.fetchUsers(distinctValues[0]);
      rows.push(
        print.twoColumnLeftAlign(
          `Waiter`,
          `: ${waiter?.name || "-"}`,
          12,
          0,
          28
        )
      );
      rows.push(print.breakLine(40, "="));
      rows.push(print.breakLine(40, " "));

      // Add order items
      for await (const item of items) {
        const waiterItem =
          distinctValues.length > 1
            ? await this.fetchUsers(item.create_by)
            : await this.fetchUsers(distinctValues[0]);

        rows.push(
          print.oneLine(
            `${item.name} (${item.quantity}) ${
              item.order_type == "take_away" ? "(Take Away)" : ""
            } ${item.status == "canceled" ? "(canceled)" : ""}`,
            36
          )
        );

        if (distinctValues.length > 1) {
          rows.push(
            print.twoColumnLeftAlign(
              `Diorder oleh`,
              `: ${waiterItem?.name || "-"}`,
              12,
              2,
              26
            )
          );
        }
        if (item.note) {
          rows.push(
            print.twoColumnLeftAlign(`Note`, `: ${item.note}`, 4, 2, 34)
          );
        }
        rows.push(print.breakLine(40, " "));
      }

      // Join all rows with newlines and add some spacing
      rows.push(print.breakLine(40, "="));

      printText = rows.join("\n");

      return printText;
    },
    async print(divId, isChecker) {
      try {
        const element = document.getElementById(divId);
        if (!element) {
          throw new Error("Print element not found");
        }

        // Show the element temporarily to capture it
        // element.style.display = "block";

        // Convert the element to text format suitable for ESC/POS
        let printText;
        let allOrderItems = this.order_items;
        let checkTotalCheckerNotPrinted = allOrderItems.filter(
          (item) => item.is_print_checker == false
        );
        if (isChecker) {
          if (checkTotalCheckerNotPrinted.length > 0) {
            printText = await this.formatChecker(element);
          } else {
            throw new Error("All items have been printed");
          }
        } else {
          printText = await this.formatElementForPrinting(element);
        }

        // Hide the element again
        element.style.display = "none";

        console.log("printText:", printText);

        // Send to backend printer endpoint
        const print_url =
          process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

        const response = await axios.post(print_url, {
          text: printText,
          printer_ip: process.env.VUE_APP_CASIER_IP,
        });
        console.log(response);

        if (checkTotalCheckerNotPrinted.length > 0) {
          for (let i in checkTotalCheckerNotPrinted) {
            await this.$store.dispatch(
              "sales_order_menus/updateSalesOrderMenu",
              {
                id: checkTotalCheckerNotPrinted[i].id,
                is_print_checker: true,
              }
            );
          }
        }

        // Optional: Show success message
        console.log("Print job sent successfully");
      } catch (error) {
        console.error("Print error:", error);
        this.errorMessage = "Failed to print: " + error.message;
        this.showErrorDialog = true;
      }
    },
    async printKitchen(item) {
      try {
        item.item_detail = this.allItems.find((i) => i.id === item.item_id);
        // Then get the category with printer list
        item.item_categories = this.allItemCategories.find(
          (ic) => ic.id === item.item_detail?.item_category_id
        );

        const element = document.getElementById("checker-print");
        if (!element) {
          throw new Error("Print element not found");
        }

        // Show the element temporarily to capture it
        // element.style.display = "block";

        // Convert the element to text format suitable for ESC/POS
        let printText;

        item?.item_categories?.printer_list?.forEach(async (printer) => {
          printText = await this.formatKitchen(item, printer.name);
          // Hide the element again
          element.style.display = "none";
          console.log("printText:", printText);
          let printItem = print.twoColumnLeftAlign(
            `Item`,
            `: ${item.name} ${item.status == "canceled" ? "(canceled)" : ""}`,
            12,
            0,
            28
          );
          console.log("printItem:", printItem);

          // Send to backend printer endpoint
          const print_url =
            process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printText,
            printer_ip: printer.printer_ip,
          });
          console.log(response);
        });

        // Optional: Show success message
        console.log("Print job sent successfully");
      } catch (error) {
        console.error("Print error:", error);
        this.errorMessage = "Failed to print: " + error.message;
        this.showErrorDialog = true;
      }
    },
    async printChecker(data) {
      try {
        const element = document.getElementById("checker-print");
        if (!element) {
          throw new Error("Print element not found");
        }

        // Show the element temporarily to capture it
        // element.style.display = "block";

        // Convert the element to text format suitable for ESC/POS
        let printText;

        printText = await this.formatChecker(
          data.items,
          data.isTransaction
            ? this.transaction.createdAt
            : data.items[0].createdAt || new Date()
        );

        // Hide the element again
        element.style.display = "none";

        console.log("printText tes:", printText);

        // Send to backend printer endpoint
        const print_url =
          process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

        const response = await axios.post(print_url, {
          text: printText,
          printer_ip: process.env.VUE_APP_CASIER_IP,
        });
        console.log(response);
        // Optional: Show success message
        console.log("Print job sent successfully");
      } catch (error) {
        console.error("Print error:", error);
        this.errorMessage = "Failed to print: " + error.message;
        this.showErrorDialog = true;
      }
    },
    handleTableSelected(table) {
      if (this.canReserve.includes(table.status)) {
        this.selectedTableId = table.id;
      }
    },
    confirmVoidTransaction(note) {
      const routeQuery = this.$route.query;

      let orderId = routeQuery.orderId;
      this.$confirm.require({
        group: "headless",
        header: "Apakah anda yakin ingin void transaksi ini?",
        message: "Silahkan konfirmasi sebelum diproses.",
        accept: async () => {
          this.allowedSave = false;
          const response = await this.postVoidTransaction(orderId, note);
          const salesOrder = response.data;
          this.$toast.add({
            severity: "success",
            summary: "Sukses",
            detail: `Kamu telah membatalkan transaksi ${salesOrder.code}.`,
            life: 5000,
          });

          this.showAlert = true;
          this.alertMessage = `Kamu telah membatalkan transaksi ${salesOrder.code}.`;
          this.headerAlert = "Sukses";
        },
        reject: () => {
          this.$toast.add({
            severity: "error",
            summary: "Rejected",
            detail: `Kamu telah membatalkan transaksi ${this.transaction.code}.`,
            life: 5000,
          });
          this.checkAndRefreshOrder();
        },
      });
    },
    async postVoidTransaction(orderId, note) {
      this.order_items = this.order_items.filter(
        (item) => item.isEdit === false
      );
      try {
        const response = await this.updateSalesOrder({
          id: orderId,
          table_id: this.transaction.table_id, // Fix: Use table_id instead of table
          marketing_id: this.transaction.marketing_id,
          //   payment_method_id: null,
          cash_register_id:
            this.transaction.cash_register_id == null
              ? this.relevantCashRegister?.id
              : this.transaction.cash_register_id,
          transaction_type_id: this.transaction.transaction_type_id,
          customer_name: this.transaction.customer_name,
          customer_phone: "",
          sub_total: 0,
          grand_total: 0,
          status: "canceled", // DataTypes.ENUM("pending", "paid", "canceled")
          order_type: this.transaction.order_type, // DataTypes.ENUM("dine_in", "take_away", "delivery")
          payment_amount: 0,
          payment_change: 0,
          tax: 0,
          service_charge: 0,
          discount: 0,
          note: note,
        });

        const orderItems = this.order_items;
        const tempOrderItems = [];
        for (let key = 0; key < orderItems.length; key++) {
          const orderItem = orderItems[key];
          const existingItem = tempOrderItems.find(
            (item) => item.item_id === orderItem.item_id
          );
          if (existingItem) {
            existingItem.quantity +=
              (orderItem?.status === "canceled" ? -1 : 1) * orderItem.quantity;
          } else {
            tempOrderItems.push(orderItem);
          }
        }

        if (tempOrderItems.length > 0) {
          for (let key = 0; key < tempOrderItems.length; key++) {
            const orderItem = tempOrderItems[key];

            if (orderItem.quantity > 0) {
              const response = await this.createSalesOrderMenu({
                sales_order_id: orderId,
                item_id: orderItem.item_id,
                qty: orderItem.quantity,
                price: orderItem.price,
                discount_price: orderItem.discount_price,
                note: orderItem.note,
                status: "canceled",
                is_print_kitchen: true,
                is_print_checker: true,
                order_type: this.transaction.order_type,
                create_by: this.detailUser.id,
              });
              console.log(response.data);
            }
          }
        }

        return response;
      } catch (error) {
        // Handle error message
        this.$toast.add({
          severity: "error",
          summary: "Rejected",
          detail: "Kamu telah membatalkan transaksi SOD000002.",
          life: 5000,
        });
        this.checkAndRefreshOrder();
      }
    },
    closeCustomerModal() {
      this.modalShowCustomer = false;
      console.log(this.transaction);
    },
    showModalCustomer() {
      if (!["paid", "canceled"].includes(this.transaction?.status)) {
        this.modalShowCustomer = true;
      } else {
        this.errorMessage = "Transaksi sudah selesai. Tidak dapat mengubah pelanggan.";
        this.showErrorDialog = true;
      }
    },
    async selectCustomer(customer) {
      this.transaction.customer_name = customer.fullname;
      this.transaction.customer_phone = customer.phone;

      let update = {
        id: this.order_id,
        table_id: this.transaction.table_id, // Fix: Use table_id instead of table
        marketing_id: this.transaction.marketing_id,
        //   payment_method_id: null,
        customer_id: customer?.id || null,
        cash_register_id:
          this.transaction.cash_register_id == null
            ? this.relevantCashRegister?.id
            : this.transaction.cash_register_id,
        transaction_type_id: this.transaction.transaction_type_id,
        customer_name: customer.fullname,
        customer_phone: customer.phone,
        sub_total: this.viewDetailTotal.find((d) => d.field == "Sub Total")
          .value,
        grand_total: this.viewDetailTotal.find((d) => d.field == "Total").value,
        status: "pending", // DataTypes.ENUM("pending", "paid", "canceled")
        order_type: this.transaction.order_type, // DataTypes.ENUM("dine_in", "take_away", "delivery")
        payment_amount: 0,
        payment_change: 0,
        tax: this.taxTotal,
        service_charge: 0,
        discount: this.viewDetailTotal.find((d) => d.field == "Diskon").value,
        note: "",
      };
      console.log("customer", customer, update)
      await this.updateSalesOrder(update);
      this.modalShowCustomer = false;
    },
    async resetCustomer() {
      if (["paid", "canceled"].includes(this.transaction?.status)) {
        this.errorMessage = "Transaksi sudah selesai. Tidak dapat mengubah pelanggan.";
        this.showErrorDialog = true;
        return;
      }
      this.transaction.customer_name = null;
      let update = {
        id: this.order_id,
        table_id: this.transaction.table_id, // Fix: Use table_id instead of tables
        marketing_id: this.transaction.marketing_id,
        //   payment_method_id: null,
        cash_register_id:
          this.transaction.cash_register_id == null
            ? this.relevantCashRegister?.id
            : this.transaction.cash_register_id,
        transaction_type_id: this.transaction.transaction_type_id,
        customer_name: "",
        customer_phone: "",
        sub_total: this.viewDetailTotal.find((d) => d.field == "Sub Total")
          .value,
        grand_total: this.viewDetailTotal.find((d) => d.field == "Total").value,
        status: "pending", // DataTypes.ENUM("pending", "paid", "canceled")
        order_type: this.transaction.order_type, // DataTypes.ENUM("dine_in", "take_away", "delivery")
        payment_amount: 0,
        payment_change: 0,
        tax: this.taxTotal,
        service_charge: 0,
        discount: this.viewDetailTotal.find((d) => d.field == "Diskon").value,
        note: "",
      };
      await this.updateSalesOrder(update);
    },
    showModalMixItem(product) {
      this.selectedProduct = product;
      this.showModalMix = true;
      this.isBlur = true;
      product.product_mix = product.product_mix.map((item) => {
        return {
          id: item.id,
          name: item.name,
          details: this.allItems.find((i) => i.id === item.id),
          price: item.price,
          sale_price: parseFloat(item.price),
          category_id: item.category_id,
          itemCategory: this.allItemCategories.find(
            (category) => category.id === item.category_id
          ),
          discount_price: parseFloat(item.discount_price),
          service_charge_applied: item.service_charge_applied,
          tax_applied: item.tax_applied,
          discount_applied: item.discount_applied,
          outlet_id: item.outlet_id,
          max_qty: item.max_qty,
          image: item.image_url ? `${process.env.VUE_APP_WEBSOCKET_URL}/file/${item.image_url}` : null,
        };
      });
      this.chooseMixItem = product;
    },
    editMixItem(product) {
      this.selectedProduct = product;
      this.showModalMix = true;
      this.isBlur = true;
      this.chooseMixItem = product;
    },
    closeModalMix() {
      setTimeout(() => {
        this.showModalMix = false;
        this.isBlur = false;
        this.chooseMixItem = null;
      }, 200);
    },
    submitMixItem(itemMix) {
      let lastId = this.order_items.reduce(
        (max, item) => (item.id > max ? item.id : max),
        0
      );

      const orderItemMix = this.order_items.findIndex(
        (item) => item.id === itemMix.id
      );
      if (orderItemMix > -1) {
        this.order_items[orderItemMix] = {
          id: itemMix.id,
          item_id: itemMix.item_id,
          name: itemMix.name,
          quantity: 1,
          price: itemMix.price,
          subtotal: parseFloat(itemMix.price) * 1,
          payment_status: 1,
          note: null,
          isEdit: true,
          isPrint: true,
          status: "unsaved",
          discount_price: itemMix.discount_price,
          total: parseFloat(itemMix.price - itemMix.discount_price) * 1,
          created_at: new Date(),
          is_print_checker: false,
          is_print_kitchen: false,
          order_type: this.transaction.order_type,
          service_charge_applied: itemMix.service_charge_applied,
          tax_applied: itemMix.tax_applied,
          discount_applied: itemMix.discount_applied,
          createdAt: new Date(),
          create_by: this.detailUser.id,
          has_product_mix: itemMix.has_product_mix,
          product_mix: itemMix.product_mix,
          selected_product_mix: itemMix.selected_product_mix,
          mix_qty_per_unit: itemMix.mix_qty_per_unit,
          totalBeforeDiscount: parseFloat(itemMix.price) * 1,
          totalAfterDiscount: parseFloat(itemMix.price - itemMix.discount_price) * 1,
        };
      } else {
        this.order_items.push({
          id: lastId + 1,
          item_id: itemMix.item_id,
          name: itemMix.name,
          quantity: 1,
          price: itemMix.price,
          subtotal: parseFloat(itemMix.price) * 1,
          payment_status: 1,
          note: null,
          isEdit: true,
          isPrint: true,
          status: "unsaved",
          discount_price: itemMix.discount_price,
          total: parseFloat(itemMix.price - itemMix.discount_price) * 1,
          created_at: new Date(),
          is_print_checker: false,
          is_print_kitchen: false,
          order_type: this.transaction.order_type,
          service_charge_applied: itemMix.service_charge_applied,
          tax_applied: itemMix.tax_applied,
          discount_applied: itemMix.discount_applied,
          createdAt: new Date(),
          create_by: this.detailUser.id,
          has_product_mix: itemMix.has_product_mix,
          product_mix: itemMix.product_mix,
          selected_product_mix: itemMix.selected_product_mix,
          mix_qty_per_unit: itemMix.mix_qty_per_unit,
          totalBeforeDiscount: parseFloat(itemMix.price) * 1,
          totalAfterDiscount: parseFloat(itemMix.price - itemMix.discount_price) * 1,
        });
      }
      console.log("submitMixItem order items", this.order_items);
      this.closeModalMix();
    },
  },
  mounted: function () {},
};
</script>
